module.exports = __webpack_public_path__ + "img/20190530161340782.a1534517.png";